import React from 'react';

import Fade from '@smart-tv/components/fade/fade';

import FeedbackDialogContent, {
  Props as FeedbackDialogContentProps
} from './feedback-dialog-content';

interface Props extends FeedbackDialogContentProps {
  open: boolean;
}

export const FeedbackDialog = (props: Props) => {
  const { open, ...contentProps } = props;

  return (
    <Fade in={open} unmountOnExit>
      <FeedbackDialogContent {...contentProps} />
    </Fade>
  );
};

export default FeedbackDialog;
